// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import { useTooltip, ToolTip } from 'components/common/ToolTip'
import Icon from 'components/common/Icon'
import { AtsLockContext, LockIcon } from 'components/common/AtsLock'

// default action component
export const SwitchAction = ({
  kebab = false,
  atsLock = false,
  disabled = false,
  ...props
}) => {
  const lockMessage = React.useContext(AtsLockContext)
  const lockText = atsLock && lockMessage ? lockMessage : props.message
  const isDisabled = atsLock && lockMessage ? true : disabled
  return kebab ? (
    <MenuAction {...props} message={lockText} disabled={isDisabled} />
  ) : (
    <ToolAction {...props} message={lockText} disabled={isDisabled} />
  )
}

// action in a toolbar
export const ToolAction = ({
  icon,
  label,
  small = label ? false : true,
  primary = false,
  helpText,
  message,
  onClick,
  warning = false,
  disabled = false,
}) => {
  const [anchorProps, tetherProps] = useTooltip()
  const toolTipText = Boolean(message) ? message : helpText
  return (
    <>
      <div
        className={cx('Action', {
          small,
          primary: primary && !disabled,
          warning,
          disabled,
        })}
        onClick={disabled ? null : onClick}
        role="button"
        {...anchorProps}
      >
        {message && <LockIcon />}
        {icon && (
          <span className="icon">
            <Icon name={icon} />
          </span>
        )}
        {!small && label && <span className="label">{label}</span>}
      </div>
      {toolTipText && <ToolTip {...tetherProps}>{toolTipText}</ToolTip>}
    </>
  )
}

// action inside a dropdown (kebab) menu
export const MenuAction = ({
  icon,
  label = 'tool action',
  helpText,
  onClick,
  disabled = false,
  warning = false,
  primary = false,
  message,
}) => {
  const [anchorProps, tetherProps] = useTooltip()
  return (
    <>
      <div
        onClick={disabled ? null : onClick}
        className={cx('MenuItemAction', {
          disabled,
          warning,
          primary: primary && !disabled,
        })}
      >
        {message && <LockIcon />}
        <span className="icon" {...anchorProps}>
          <Icon name={icon} />
        </span>
        <span className="label">{label}</span>
        <span className="helptext">{helpText}</span>
      </div>
      {message && <ToolTip {...tetherProps}>{message}</ToolTip>}
    </>
  )
}
